module.exports = __webpack_public_path__ + "static/kran04_450-14d4ccfb25a072782648ea26be20acf5.jpg";